export function drawingDate(value) {
  if (value == null || typeof value === 'boolean' || value === '' || value === 0) return null;
  const date = new Date(typeof value === 'string' ? value.trim() : value);
  return Number.isFinite(date.getTime()) ? date : null;
}

export function formatDrawingDate(value, empty = 'Дата не указана') {
  const date = drawingDate(value);
  return date ? date.toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }) : empty;
}

export function eventDrawingDate(event) {
  if (drawingDate(event?.date)) return formatDrawingDate(event.date);
  const day = event?.date_event;
  const time = event?.time_event || event?.time_from || '00:00:00';
  return formatDrawingDate(day ? `${day}T${time}` : null, 'Дата замера не указана');
}

export function showDrawingDeadline(event) {
  const quality = event?.quality?.state || event?.qa_state;
  return !event?.draftsmen_event?.is_completed && event?.state !== 'completed'
    && !['pending', 'passed', 'rework'].includes(quality);
}

// A missing billing area is not a measured zero; recovery keeps it separate.
export function drawingInputSquare(drawing) {
  const value = drawing?.recovery_mode ? drawing.actual_square
    : Number(drawing?.square) > 0 ? drawing.square : drawing?.actual_square;
  if (value == null || value === '' || typeof value === 'boolean') return '';
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : '';
}

export function billingSquareLabel(value) {
  if (value == null || value === '' || typeof value === 'boolean') return 'не указана';
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? `${number} м²` : 'не указана';
}
